import styled from "styled-components";
import Form from "antd/lib/form";
export const FormElement = styled(Form)``;
export const FormFooter = styled.div`
  > * {
    width: 100%;
  }
`;
